import React from 'react';

import Link from 'next/link';

interface FooterNavLinkProps {
  list: Array<{ link: string; title: string }>;
  title: string;
}

function FooterNavLink({ title, list }: FooterNavLinkProps) {
  return (
    <div>
      <h5 className="pb-3 text-base font-semibold text-black-default md:pb-5 md:text-lg">
        {title}
      </h5>
      <ul className="flex flex-col items-start gap-2 md:gap-5">
        {list.map((link) => {
          return (
            <li key={link.link}>
              <Link
                href={link.link}
                className="text-sm font-medium text-black-400 md:text-base"
              >
                {link.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default FooterNavLink;
